/* import __COLOCATED_TEMPLATE__ from './adi-message-panel.hbs'; */
import Component from '@glimmer/component';

export default class AdiMessagePanel extends Component {
  messageClassName = 'message-container';
  messageItemClassName = 'message-item';

  get internalMessages() {
    if (this.args.messages && Array.isArray(this.args.messages)) return this.args.messages;
    else if (this.args.message) return [this.args.message];
    else return null;
  }

  get iconClassName() {
    return this.args.iconClassName ?? 'warning-icon';
  }
}
